import { hits, refinementList, currentRefinements, clearRefinements, configure } from 'instantsearch.js/es/widgets';
import { connectStats, connectPagination } from 'instantsearch.js/es/connectors';

const decodeHtmlEntities = (str: string): string => {
  const doc = new DOMParser().parseFromString(str, 'text/html');
  return doc.documentElement.textContent ?? str;
};

// HITS
const getRessourceHitsWidgets = (container: HTMLElement) => {
  return hits({
    container,
    cssClasses: {
      root: 'posts-grid',
      list: 'posts-grid__wrapper',
    },
    templates: {
      item(data, { html }) {
        const {
          post_type,
          title,
          permalink,
          is_reserved,
          is_video,
          libelle_link,
          format_label,
          thematics_label,
          thematics_color,
          thematics_color_hover,
          thumbnail_url,
          date,
        } = data;

      const formattedDate = date
      ? new Intl.DateTimeFormat('fr-FR', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
      }).format(new Date(date * 1000)) : '';

      const defaultImages: Record<string, string> = {
        'ressource': '/app/themes/limpide-starter/assets/img/png/default-ressource.webp',
        'prise-position': '/app/themes/limpide-starter/assets/img/png/default-prise-position.webp',
        'post': '/app/themes/limpide-starter/assets/img/png/default-post.webp',
      };
      const placeholderImage = defaultImages[post_type] ?? defaultImages['post'];

      // rendu pour les autres (comportement par défaut)
      if (post_type !== 'post') {
        return html`
            <a href="${permalink}"
               class="card card-ressource card-link"
               title="${decodeHtmlEntities(title)}"
               target="_self"
               style="${thematics_color ? `--tint-color: ${thematics_color};` : ''}--card-background-color:#f5f4f8;"
            >
                <div class="card-tags-content">
                    <span class="card-tag ontitle"
                          style="--color: ${thematics_color}; --color-hover: ${thematics_color_hover};">${thematics_label}</span>
                    <span class="card-format ontitle">${format_label}</span>
                </div>
                ${thumbnail_url ? html`
                    <div class="card-image wrapper-image">
                        <img width="352" height="240"
                             src="${thumbnail_url}"
                             class="attachment-card-image size-card-image" alt="" loading="lazy" decoding="async"
                             fetchpriority="low"/>
                        <div class="card-reserved ${is_reserved ? '' : 'hidden'}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <g clip-path="url(#clip0_1430_3927)">
                                    <path
                                            d="M12.6667 6.66667H13.3333C13.5101 6.66667 13.6797 6.73691 13.8047 6.86193C13.9298 6.98695 14 7.15652 14 7.33333V14C14 14.1768 13.9298 14.3464 13.8047 14.4714C13.6797 14.5964 13.5101 14.6667 13.3333 14.6667H2.66667C2.48986 14.6667 2.32029 14.5964 2.19526 14.4714C2.07024 14.3464 2 14.1768 2 14V7.33333C2 7.15652 2.07024 6.98695 2.19526 6.86193C2.32029 6.73691 2.48986 6.66667 2.66667 6.66667H3.33333V6C3.33333 5.38716 3.45404 4.78033 3.68856 4.21414C3.92308 3.64796 4.26683 3.13351 4.70017 2.70017C5.13351 2.26683 5.64796 1.92308 6.21414 1.68856C6.78033 1.45404 7.38716 1.33333 8 1.33333C8.61284 1.33333 9.21967 1.45404 9.78586 1.68856C10.352 1.92308 10.8665 2.26683 11.2998 2.70017C11.7332 3.13351 12.0769 3.64796 12.3114 4.21414C12.546 4.78033 12.6667 5.38716 12.6667 6V6.66667ZM3.33333 8V13.3333H12.6667V8H3.33333ZM7.33333 9.33333H8.66667V12H7.33333V9.33333ZM11.3333 6.66667V6C11.3333 5.11595 10.9821 4.2681 10.357 3.64298C9.7319 3.01786 8.88406 2.66667 8 2.66667C7.11595 2.66667 6.2681 3.01786 5.64298 3.64298C5.01786 4.2681 4.66667 5.11595 4.66667 6V6.66667H11.3333Z"
                                            fill="currentColor"></path>
                                </g>
                                <defs>
                                    <clipPath id="clip0_1430_3927">
                                        <rect width="16" height="16" fill="white"></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                            <span class="reserved-label">Contenu réservé</span>
                        </div>
                        <div class="card-icon-video ${is_video ? '' : 'hidden'}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                <path d="M13.8386 7.34732C14.6477 7.83283 14.6477 9.00555 13.8386 9.49106L1.89312 16.6583C1.05996 17.1582 5.19928e-08 16.5581 9.28603e-08 15.5865L6.95789e-07 1.25193C7.36657e-07 0.280309 1.05996 -0.319832 1.89312 0.180061L13.8386 7.34732Z"
                                      fill="black"/>
                            </svg>
                        </div>
                  </div>
                ` : placeholderImage ? html`
                  <div class="card-image wrapper-image">
                      <img width="352" height="240"
                        src="${placeholderImage}"
                        class="attachment-card-image size-card-image" alt="" loading="lazy" decoding="async"
                        fetchpriority="low" aria-hidden="true"/>
                  </div>
                ` : html`
                    <div class="card-image card-image-placeholder">
                        <div class="card-image-placeholder-logo">
                          <svg width="120" height="60" viewBox="0 0 120 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="120" height="60" fill="white"/>
                            <path d="M46.966 25.004H48.156V35H46.966V25.004ZM50.8675 31.388C50.8675 31.8267 50.9235 32.2187 51.0355 32.564C51.1568 32.9 51.3202 33.1847 51.5255 33.418C51.7308 33.642 51.9688 33.8147 52.2395 33.936C52.5195 34.0573 52.8135 34.118 53.1215 34.118C53.4295 34.118 53.7188 34.0573 53.9895 33.936C54.2695 33.8147 54.5122 33.642 54.7175 33.418C54.9228 33.1847 55.0815 32.9 55.1935 32.564C55.3148 32.2187 55.3755 31.8267 55.3755 31.388C55.3755 30.9493 55.3148 30.562 55.1935 30.226C55.0815 29.8807 54.9228 29.5913 54.7175 29.358C54.5122 29.1247 54.2695 28.9473 53.9895 28.826C53.7188 28.7047 53.4295 28.644 53.1215 28.644C52.8135 28.644 52.5195 28.7047 52.2395 28.826C51.9688 28.9473 51.7308 29.1247 51.5255 29.358C51.3202 29.5913 51.1568 29.8807 51.0355 30.226C50.9235 30.562 50.8675 30.9493 50.8675 31.388ZM49.6075 31.388C49.6075 30.856 49.6822 30.3613 49.8315 29.904C49.9808 29.4373 50.2048 29.036 50.5035 28.7C50.8022 28.3547 51.1708 28.084 51.6095 27.888C52.0482 27.692 52.5522 27.594 53.1215 27.594C53.7002 27.594 54.2042 27.692 54.6335 27.888C55.0722 28.084 55.4408 28.3547 55.7395 28.7C56.0382 29.036 56.2622 29.4373 56.4115 29.904C56.5608 30.3613 56.6355 30.856 56.6355 31.388C56.6355 31.92 56.5608 32.4147 56.4115 32.872C56.2622 33.3293 56.0382 33.7307 55.7395 34.076C55.4408 34.412 55.0722 34.678 54.6335 34.874C54.2042 35.0607 53.7002 35.154 53.1215 35.154C52.5522 35.154 52.0482 35.0607 51.6095 34.874C51.1708 34.678 50.8022 34.412 50.5035 34.076C50.2048 33.7307 49.9808 33.3293 49.8315 32.872C49.6822 32.4147 49.6075 31.92 49.6075 31.388ZM64.2826 34.384C64.2826 35.5693 64.0119 36.456 63.4706 37.044C62.9292 37.632 62.0799 37.926 60.9226 37.926C60.5866 37.926 60.2412 37.8887 59.8866 37.814C59.5412 37.7393 59.2239 37.618 58.9346 37.45C58.6546 37.282 58.4212 37.0627 58.2346 36.792C58.0479 36.5213 57.9452 36.19 57.9266 35.798H59.1166C59.1259 36.0127 59.1912 36.1947 59.3126 36.344C59.4432 36.4933 59.5972 36.6147 59.7746 36.708C59.9612 36.8013 60.1619 36.8667 60.3766 36.904C60.5912 36.9507 60.7966 36.974 60.9926 36.974C61.3846 36.974 61.7159 36.904 61.9866 36.764C62.2572 36.6333 62.4812 36.4467 62.6586 36.204C62.8359 35.9707 62.9619 35.686 63.0366 35.35C63.1206 35.014 63.1626 34.6453 63.1626 34.244V33.768H63.1346C62.9292 34.216 62.6166 34.5473 62.1966 34.762C61.7859 34.9673 61.3472 35.07 60.8806 35.07C60.3392 35.07 59.8679 34.972 59.4666 34.776C59.0652 34.58 58.7292 34.3187 58.4586 33.992C58.1879 33.656 57.9826 33.2687 57.8426 32.83C57.7119 32.382 57.6466 31.9107 57.6466 31.416C57.6466 30.9867 57.7026 30.548 57.8146 30.1C57.9266 29.6427 58.1132 29.232 58.3746 28.868C58.6359 28.4947 58.9812 28.1913 59.4106 27.958C59.8399 27.7153 60.3672 27.594 60.9926 27.594C61.4499 27.594 61.8699 27.6967 62.2526 27.902C62.6352 28.098 62.9339 28.3967 63.1486 28.798H63.1626V27.762H64.2826V34.384ZM60.9506 34.034C61.3426 34.034 61.6739 33.9547 61.9446 33.796C62.2246 33.628 62.4486 33.4133 62.6166 33.152C62.7846 32.8813 62.9059 32.578 62.9806 32.242C63.0646 31.906 63.1066 31.57 63.1066 31.234C63.1066 30.9167 63.0692 30.604 62.9946 30.296C62.9199 29.988 62.7986 29.7127 62.6306 29.47C62.4719 29.218 62.2619 29.0173 62.0006 28.868C61.7392 28.7187 61.4219 28.644 61.0486 28.644C60.6659 28.644 60.3392 28.7187 60.0686 28.868C59.7979 29.008 59.5739 29.1993 59.3966 29.442C59.2286 29.6847 59.1026 29.9647 59.0186 30.282C58.9439 30.5993 58.9066 30.9307 58.9066 31.276C58.9066 31.6027 58.9392 31.9293 59.0046 32.256C59.0699 32.5827 59.1819 32.8813 59.3406 33.152C59.4992 33.4133 59.7092 33.628 59.9706 33.796C60.2319 33.9547 60.5586 34.034 60.9506 34.034ZM66.9456 31.388C66.9456 31.8267 67.0016 32.2187 67.1136 32.564C67.235 32.9 67.3983 33.1847 67.6036 33.418C67.809 33.642 68.047 33.8147 68.3176 33.936C68.5976 34.0573 68.8916 34.118 69.1996 34.118C69.5076 34.118 69.797 34.0573 70.0676 33.936C70.3476 33.8147 70.5903 33.642 70.7956 33.418C71.001 33.1847 71.1596 32.9 71.2716 32.564C71.393 32.2187 71.4536 31.8267 71.4536 31.388C71.4536 30.9493 71.393 30.562 71.2716 30.226C71.1596 29.8807 71.001 29.5913 70.7956 29.358C70.5903 29.1247 70.3476 28.9473 70.0676 28.826C69.797 28.7047 69.5076 28.644 69.1996 28.644C68.8916 28.644 68.5976 28.7047 68.3176 28.826C68.047 28.9473 67.809 29.1247 67.6036 29.358C67.3983 29.5913 67.235 29.8807 67.1136 30.226C67.0016 30.562 66.9456 30.9493 66.9456 31.388ZM65.6856 31.388C65.6856 30.856 65.7603 30.3613 65.9096 29.904C66.059 29.4373 66.283 29.036 66.5816 28.7C66.8803 28.3547 67.249 28.084 67.6876 27.888C68.1263 27.692 68.6303 27.594 69.1996 27.594C69.7783 27.594 70.2823 27.692 70.7116 27.888C71.1503 28.084 71.519 28.3547 71.8176 28.7C72.1163 29.036 72.3403 29.4373 72.4896 29.904C72.639 30.3613 72.7136 30.856 72.7136 31.388C72.7136 31.92 72.639 32.4147 72.4896 32.872C72.3403 33.3293 72.1163 33.7307 71.8176 34.076C71.519 34.412 71.1503 34.678 70.7116 34.874C70.2823 35.0607 69.7783 35.154 69.1996 35.154C68.6303 35.154 68.1263 35.0607 67.6876 34.874C67.249 34.678 66.8803 34.412 66.5816 34.076C66.283 33.7307 66.059 33.3293 65.9096 32.872C65.7603 32.4147 65.6856 31.92 65.6856 31.388Z" fill="black"/>
                          </svg>
                        </div>
                        <div class="card-reserved ${is_reserved ? '' : 'hidden'}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <g clip-path="url(#clip0_1430_3927_b)">
                                    <path
                                            d="M12.6667 6.66667H13.3333C13.5101 6.66667 13.6797 6.73691 13.8047 6.86193C13.9298 6.98695 14 7.15652 14 7.33333V14C14 14.1768 13.9298 14.3464 13.8047 14.4714C13.6797 14.5964 13.5101 14.6667 13.3333 14.6667H2.66667C2.48986 14.66667 2.32029 14.5964 2.19526 14.4714C2.07024 14.3464 2 14.1768 2 14V7.33333C2 7.15652 2.07024 6.98695 2.19526 6.86193C2.32029 6.73691 2.48986 6.66667 2.66667 6.66667H3.33333V6C3.33333 5.38716 3.45404 4.78033 3.68856 4.21414C3.92308 3.64796 4.26683 3.13351 4.70017 2.70017C5.13351 2.26683 5.64796 1.92308 6.21414 1.68856C6.78033 1.45404 7.38716 1.33333 8 1.33333C8.61284 1.33333 9.21967 1.45404 9.78586 1.68856C10.352 1.92308 10.8665 2.26683 11.2998 2.70017C11.7332 3.13351 12.0769 3.64796 12.3114 4.21414C12.546 4.78033 12.6667 5.38716 12.6667 6V6.66667ZM3.33333 8V13.3333H12.6667V8H3.33333ZM7.33333 9.33333H8.66667V12H7.33333V9.33333ZM11.3333 6.66667V6C11.3333 5.11595 10.9821 4.2681 10.357 3.64298C9.7319 3.01786 8.88406 2.66667 8 2.66667C7.11595 2.66667 6.2681 3.01786 5.64298 3.64298C5.01786 4.2681 4.66667 5.11595 4.66667 6V6.66667H11.3333Z"
                                            fill="currentColor"></path>
                                </g>
                                <defs>
                                    <clipPath id="clip0_1430_3927_b">
                                        <rect width="16" height="16" fill="white"></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                            <span class="reserved-label">Contenu réservé</span>
                        </div>
                    </div>
                `}
                <div class="card-content">
                    <h3 class="card-title">${decodeHtmlEntities(title)}</h3>
                    <span class="btn btn-simple btn-primary">
                ${libelle_link ? libelle_link : 'Lire la suite'}
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                          d="M1.33319 10.0001L1.3331 8.6668H12.1144L9.48123 6.03363L10.424 5.09082L14.6667 9.33347L10.424 13.5761L9.48123 12.6333L12.1144 10.0001L1.33319 10.0001Z"
                          fill="currentColor"></path>
                </svg>
              </span>
                </div>
            </a>
        `;
      }

      // rendu spécifique pour les posts
      return html`
        <a href="${permalink}"
          class="card card-link"
          title="${decodeHtmlEntities(title)}"
          target="_self"
          style=";--card-background-color:#f5f4f8"
        >
          <div class="card-tags-content">
            <span class="card-tag ontitle">${thematics_label}</span>
            <span class="card-format ontitle">${formattedDate}</span>
          </div>
          ${thumbnail_url ? html`
            <div class="card-image wrapper-image">
              <img width="352" height="240"
                src="${thumbnail_url}"
                class="attachment-card-image size-card-image" alt="" loading="lazy" decoding="async"
                fetchpriority="low"/>
            </div>
          ` : placeholderImage ? html`
              <div class="card-image wrapper-image">
                  <img width="352" height="240"
                    src="${placeholderImage}"
                    class="attachment-card-image size-card-image" alt="" loading="lazy" decoding="async"
                    fetchpriority="low" aria-hidden="true"/>
              </div>
          ` : html`
            <div class="card-image card-image-placeholder">
              <div class="card-image-placeholder-logo">
                <svg width="120" height="60" viewBox="0 0 120 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="120" height="60" fill="white"/>
                  <path d="M46.966 25.004H48.156V35H46.966V25.004ZM50.8675 31.388C50.8675 31.8267 50.9235 32.2187 51.0355 32.564C51.1568 32.9 51.3202 33.1847 51.5255 33.418C51.7308 33.642 51.9688 33.8147 52.2395 33.936C52.5195 34.0573 52.8135 34.118 53.1215 34.118C53.4295 34.118 53.7188 34.0573 53.9895 33.936C54.2695 33.8147 54.5122 33.642 54.7175 33.418C54.9228 33.1847 55.0815 32.9 55.1935 32.564C55.3148 32.2187 55.3755 31.8267 55.3755 31.388C55.3755 30.9493 55.3148 30.562 55.1935 30.226C55.0815 29.8807 54.9228 29.5913 54.7175 29.358C54.5122 29.1247 54.2695 28.9473 53.9895 28.826C53.7188 28.7047 53.4295 28.644 53.1215 28.644C52.8135 28.644 52.5195 28.7047 52.2395 28.826C51.9688 28.9473 51.7308 29.1247 51.5255 29.358C51.3202 29.5913 51.1568 29.8807 51.0355 30.226C50.9235 30.562 50.8675 30.9493 50.8675 31.388ZM49.6075 31.388C49.6075 30.856 49.6822 30.3613 49.8315 29.904C49.9808 29.4373 50.2048 29.036 50.5035 28.7C50.8022 28.3547 51.1708 28.084 51.6095 27.888C52.0482 27.692 52.5522 27.594 53.1215 27.594C53.7002 27.594 54.2042 27.692 54.6335 27.888C55.0722 28.084 55.4408 28.3547 55.7395 28.7C56.0382 29.036 56.2622 29.4373 56.4115 29.904C56.5608 30.3613 56.6355 30.856 56.6355 31.388C56.6355 31.92 56.5608 32.4147 56.4115 32.872C56.2622 33.3293 56.0382 33.7307 55.7395 34.076C55.4408 34.412 55.0722 34.678 54.6335 34.874C54.2042 35.0607 53.7002 35.154 53.1215 35.154C52.5522 35.154 52.0482 35.0607 51.6095 34.874C51.1708 34.678 50.8022 34.412 50.5035 34.076C50.2048 33.7307 49.9808 33.3293 49.8315 32.872C49.6822 32.4147 49.6075 31.92 49.6075 31.388ZM64.2826 34.384C64.2826 35.5693 64.0119 36.456 63.4706 37.044C62.9292 37.632 62.0799 37.926 60.9226 37.926C60.5866 37.926 60.2412 37.8887 59.8866 37.814C59.5412 37.7393 59.2239 37.618 58.9346 37.45C58.6546 37.282 58.4212 37.0627 58.2346 36.792C58.0479 36.5213 57.9452 36.19 57.9266 35.798H59.1166C59.1259 36.0127 59.1912 36.1947 59.3126 36.344C59.4432 36.4933 59.5972 36.6147 59.7746 36.708C59.9612 36.8013 60.1619 36.8667 60.3766 36.904C60.5912 36.9507 60.7966 36.974 60.9926 36.974C61.3846 36.974 61.7159 36.904 61.9866 36.764C62.2572 36.6333 62.4812 36.4467 62.6586 36.204C62.8359 35.9707 62.9619 35.686 63.0366 35.35C63.1206 35.014 63.1626 34.6453 63.1626 34.244V33.768H63.1346C62.9292 34.216 62.6166 34.5473 62.1966 34.762C61.7859 34.9673 61.3472 35.07 60.8806 35.07C60.3392 35.07 59.8679 34.972 59.4666 34.776C59.0652 34.58 58.7292 34.3187 58.4586 33.992C58.1879 33.656 57.9826 33.2687 57.8426 32.83C57.7119 32.382 57.6466 31.9107 57.6466 31.416C57.6466 30.9867 57.7026 30.548 57.8146 30.1C57.9266 29.6427 58.1132 29.232 58.3746 28.868C58.6359 28.4947 58.9812 28.1913 59.4106 27.958C59.8399 27.7153 60.3672 27.594 60.9926 27.594C61.4499 27.594 61.8699 27.6967 62.2526 27.902C62.6352 28.098 62.9339 28.3967 63.1486 28.798H63.1626V27.762H64.2826V34.384ZM60.9506 34.034C61.3426 34.034 61.6739 33.9547 61.9446 33.796C62.2246 33.628 62.4486 33.4133 62.6166 33.152C62.7846 32.8813 62.9059 32.578 62.9806 32.242C63.0646 31.906 63.1066 31.57 63.1066 31.234C63.1066 30.9167 63.0692 30.604 62.9946 30.296C62.9199 29.988 62.7986 29.7127 62.6306 29.47C62.4719 29.218 62.2619 29.0173 62.0006 28.868C61.7392 28.7187 61.4219 28.644 61.0486 28.644C60.6659 28.644 60.3392 28.7187 60.0686 28.868C59.7979 29.008 59.5739 29.1993 59.3966 29.442C59.2286 29.6847 59.1026 29.9647 59.0186 30.282C58.9439 30.5993 58.9066 30.9307 58.9066 31.276C58.9066 31.6027 58.9392 31.9293 59.0046 32.256C59.0699 32.5827 59.1819 32.8813 59.3406 33.152C59.4992 33.4133 59.7092 33.628 59.9706 33.796C60.2319 33.9547 60.5586 34.034 60.9506 34.034ZM66.9456 31.388C66.9456 31.8267 67.0016 32.2187 67.1136 32.564C67.235 32.9 67.3983 33.1847 67.6036 33.418C67.809 33.642 68.047 33.8147 68.3176 33.936C68.5976 34.0573 68.8916 34.118 69.1996 34.118C69.5076 34.118 69.797 34.0573 70.0676 33.936C70.3476 33.8147 70.5903 33.642 70.7956 33.418C71.001 33.1847 71.1596 32.9 71.2716 32.564C71.393 32.2187 71.4536 31.8267 71.4536 31.388C71.4536 30.9493 71.393 30.562 71.2716 30.226C71.1596 29.8807 71.001 29.5913 70.7956 29.358C70.5903 29.1247 70.3476 28.9473 70.0676 28.826C69.797 28.7047 69.5076 28.644 69.1996 28.644C68.8916 28.644 68.5976 28.7047 68.3176 28.826C68.047 28.9473 67.809 29.1247 67.6036 29.358C67.3983 29.5913 67.235 29.8807 67.1136 30.226C67.0016 30.562 66.9456 30.9493 66.9456 31.388ZM65.6856 31.388C65.6856 30.856 65.7603 30.3613 65.9096 29.904C66.059 29.4373 66.283 29.036 66.5816 28.7C66.8803 28.3547 67.249 28.084 67.6876 27.888C68.1263 27.692 68.6303 27.594 69.1996 27.594C69.7783 27.594 70.2823 27.692 70.7116 27.888C71.1503 28.084 71.519 28.3547 71.8176 28.7C72.1163 29.036 72.3403 29.4373 72.4896 29.904C72.639 30.3613 72.7136 30.856 72.7136 31.388C72.7136 31.92 72.639 32.4147 72.4896 32.872C72.3403 33.3293 72.1163 33.7307 71.8176 34.076C71.519 34.412 71.1503 34.678 70.7116 34.874C70.2823 35.0607 69.7783 35.154 69.1996 35.154C68.6303 35.154 68.1263 35.0607 67.6876 34.874C67.249 34.678 66.8803 34.412 66.5816 34.076C66.283 33.7307 66.059 33.3293 65.9096 32.872C65.7603 32.4147 65.6856 31.92 65.6856 31.388Z" fill="black"/>
                </svg>
              </div>
            </div>
          `}
          <div class="card-content">
            <h3 class="card-title">${decodeHtmlEntities(title)}</h3>
            <span class="btn btn-simple btn-primary">
          ${libelle_link ? libelle_link : 'Lire l\' article'}
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M1.33319 10.0001L1.3331 8.6668H12.1144L9.48123 6.03363L10.424 5.09082L14.6667 9.33347L10.424 13.5761L9.48123 12.6333L12.1144 10.0001L1.33319 10.0001Z"
                fill="currentColor"></path>
          </svg>
          </span>
          </div>
        </a>
      `;
      },
    },
  });
};


// REFINEMENTS
const getRessourceRefinements = (container: HTMLElement, attribute: string, templateRenderer: any, excludedValues: (string | number)[] = []) => {
  return refinementList({
    container,
    attribute,
    sortBy: ['count:desc', 'name:asc'],
    templates: {
      item: templateRenderer,
    },
    transformItems(items) {
      if (!excludedValues.length) return items;
      return items.filter(item => !excludedValues.includes(item.value));
    },
  });
};


// CURRENT REFINEMENTS
const getRessourceCurrentRefinements = (container: HTMLElement) => {
  return currentRefinements({
    container,
    transformItems(items) {
      return items.map((item) => ({
        ...item,
        refinements: item.refinements.map((refinement) => ({
          ...refinement,
          label: refinement.label,
        })),
      }));
    },
  });
};

// CLEAR REFINEMENTS
const getRessourceClearRefinements = (container: HTMLElement) => {
  return clearRefinements({
    container,
    templates: {
      resetLabel({ hasRefinements }, { html }) {
        return html`<span>${hasRefinements ? 'Tout effacer' : 'Aucun filtre actif'}</span>`;
      },
    },
  });
};

// STATS
const getRessourceStats = (container: HTMLElement) => {
  return connectStats(({ nbHits }) => {
    container.textContent = nbHits ? `(${nbHits})` : '';
  })({});
};

// PAGINATION
const getRessourcePagination = (container: HTMLElement) => {
  let refineRef: ((page: number) => void) | null = null;

  container.addEventListener('click', (e) => {
    const link = (e.target as HTMLElement).closest<HTMLElement>('[data-page]');
    const headerHeight = document.querySelector('#main-header')?.clientHeight || 0;
    const targetPosition = document.getElementById('search-results-top')?.getBoundingClientRect().top || 0;

    if (link && refineRef) {
      e.preventDefault();
      refineRef(Number(link.dataset.page));

      window.scrollTo({
        top: targetPosition + window.pageYOffset - headerHeight,
        behavior: 'smooth',
      });
    }
  });

  return connectPagination(({ pages, currentRefinement, nbPages, refine }) => {
    refineRef = refine;

    if (nbPages <= 1) {
      container.innerHTML = '';
      return;
    }

    const prevDisabled = currentRefinement === 0;
    const nextDisabled = currentRefinement >= nbPages - 1;

    container.innerHTML = `
        <ul class="ais-Pagination-list">
          <li class="ais-Pagination-item ais-Pagination-item--previousPage${prevDisabled ? ' ais-Pagination-item--disabled' : ''}">
            <a class="ais-Pagination-link" 
              ${prevDisabled ? 'aria-disabled="true"' : `href="#search-results-top" data-page="${currentRefinement - 1}"`}
              aria-label="Page précédente">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_2624_368)">
                  <path d="M7.21867 8L10.5187 11.3L9.576 12.2427L5.33333 8L9.576 3.75733L10.5187 4.7L7.21867 8Z" fill="black"/>
                </g>
                <defs>
                  <clipPath id="clip0_2624_368">
                    <rect width="16" height="16" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              </a>
          </li>
          ${pages.map((page: number) => `
            <li class="ais-Pagination-item ais-Pagination-item--page${page === currentRefinement ? ' ais-Pagination-item--selected' : ''}">
              <a class="ais-Pagination-link"${page === currentRefinement ? '' : ` href="#search-results-top" data-page="${page}"`}
                aria-label="Page ${page + 1}"${page === currentRefinement ? ' aria-current="page"' : ''}>${page + 1}</a>
            </li>
          `).join('')}
          <li class="ais-Pagination-item ais-Pagination-item--nextPage${nextDisabled ? ' ais-Pagination-item--disabled' : ''}">
            <a class="ais-Pagination-link" 
              ${nextDisabled ? 'aria-disabled="true"' : `href="#search-results-top" data-page="${currentRefinement + 1}"`}
              aria-label="Page suivante">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_2624_368)">
                  <path d="M7.21867 8L10.5187 11.3L9.576 12.2427L5.33333 8L9.576 3.75733L10.5187 4.7L7.21867 8Z" fill="black"/>
                </g>
                <defs>
                  <clipPath id="clip0_2624_368">
                    <rect width="16" height="16" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              </a>
          </li>
        </ul>
    `;
  })({ padding: 2 });
};

// EXCLUDE IDS
const getRessourceExcludeIds = (excludedIds: (string | number)[]) => {
  if (!excludedIds.length) return null;
  return configure({
    filters: `id:!=[${excludedIds.join(',')}]`,
  });
};

export {
  getRessourceHitsWidgets,
  getRessourceRefinements,
  getRessourceCurrentRefinements,
  getRessourceClearRefinements,
  getRessourceExcludeIds,
  getRessourceStats,
  getRessourcePagination,
};
